import { appConfig } from "@/constants";
import type { Quest, QuestGroup } from "@ui-kit/QuestList";

const overTakeQuestsList: Quest[] = [
  {
    type: "custom",
    key: "follow",
    icon: "Add",
    label: "Follow Overtake",
    caption: "",
    increase: 10,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "e38dffc2-2d44-4b26-8e2f-c593bddececc-wishlist-added",
    ruleId: "e38dffc2-2d44-4b26-8e2f-c593bddececc-wishlist",
  },
  {
    type: "link",
    key: "website",
    icon: "Edit",
    label: "Sign up for OVERTAKE",
    caption: "",
    linkUrl: "https://overtake.world/earn/pops/OVERTAKE_SIGNUP",
    increase: 10,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "e38dffc2-2d44-4b26-8e2f-c593bddececc-website-visited",
    ruleId: "e38dffc2-2d44-4b26-8e2f-c593bddececc-website",
  },
  {
    type: "link",
    key: "website",
    icon: "TreasureChest",
    label: "Join GameFest Rewards Campaign",
    caption: "",
    linkUrl: "https://overtake.world/gamefest",
    increase: 10,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "e38dffc2-2d44-4b26-8e2f-c593bddececc-gamefest-joined",
    ruleId: "e38dffc2-2d44-4b26-8e2f-c593bddececc-gamefest",
  },
];

const goldenGuardiansQuestsList: Quest[] = [
  {
    type: "link",
    key: "website",
    icon: "Discord",
    label: "Join Golden Guardians Community",
    caption: "",
    linkUrl: "https://t.me/gg_survivor",
    increase: 5,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "664d7fc0-a589-42e2-9d82-c4d9deb8c1e0-community-joined",
    ruleId: "664d7fc0-a589-42e2-9d82-c4d9deb8c1e0-community",
  },
  {
    type: "link",
    key: "website",
    icon: "Coins",
    label: "Join Golden Guardians Launch Campaign",
    caption: "",
    linkUrl: "https://overtake.world/gamefest/launchpool/gg/global",
    increase: 5,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "664d7fc0-a589-42e2-9d82-c4d9deb8c1e0-campaign-joined",
    ruleId: "664d7fc0-a589-42e2-9d82-c4d9deb8c1e0-campaign",
  },
];

const redOneQuestsList: Quest[] = [
  {
    type: "video",
    key: "watch",
    icon: "Play",
    label: "Watch The Red One trailer",
    caption: "",
    videoMimeType: "video/mp4",
    videoUrl: `${appConfig.PLAY_ASSETS_CDN_BASE_URL}/videos/overtake/RedOneTrailer.mp4`,
    increase: 15,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "a3688e19-eb49-4bb2-9a86-5282fcbab270-trailer-watched",
    ruleId: "a3688e19-eb49-4bb2-9a86-5282fcbab270-trailer",
  },
  {
    type: "link",
    key: "website",
    icon: "ApplicationWeb",
    label: "Join The Red One UGC Campaign",
    caption: "",
    linkUrl:
      "https://docs.google.com/forms/d/e/1FAIpQLSc0KIWvD7-zXYEZ0uxLpsDzrtWWeOHZVXARkeIYrVEyArYDfw/viewform",
    increase: 15,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "a3688e19-eb49-4bb2-9a86-5282fcbab270-beta-signedup",
    ruleId: "a3688e19-eb49-4bb2-9a86-5282fcbab270-beta",
  },
];

const bonusQuestsList: Quest[] = [
  {
    type: "custom",
    key: "bonus",
    icon: "ImxRewards",
    label: "Get bonus reward",
    caption: "Extra Gems for completing all quests",
    increase: 10,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "e38dffc2-2d44-4b26-8e2f-c593bddececc-onboarding-completed",
    ruleId: "e38dffc2-2d44-4b26-8e2f-c593bddececc-onboarding",
  },
];

export const overtakeQuestsList: QuestGroup[] = [
  {
    key: "overtake",
    header: {
      image: "",
      title: "Join Overtake GameFest",
      description: "",
    },
    hideOnCompletion: true,
    totalGemsGranted: 30,
    quests: overTakeQuestsList,
  },
  {
    key: "golden-guardians",
    header: {
      image: "",
      title: "Golden Guardians: Survivor",
      description: "",
    },
    totalGemsGranted: 10,
    hideOnCompletion: true,
    quests: goldenGuardiansQuestsList,
  },
  {
    key: "red-one",
    header: {
      image: "",
      title: "The Red One: Occultation",
      description: "",
    },
    totalGemsGranted: 30,
    hideOnCompletion: true,
    quests: redOneQuestsList,
  },
  {
    key: "bonus",
    header: {
      image: "",
      title: "Get bonus rewards",
      description: "",
    },
    nextQuest: {
      // TODO: change to somni's when live
      url: "/games/norma-in-metaland",
      title: "Thanks for getting involved",
      label: "Want more? Check out Norma in Metaland",
      caption: "Earn additional rewards and support more games",
    },
    totalGemsGranted: 10,
    showOnAllCompleted: true,
    quests: bonusQuestsList,
  },
];
